import React from "react";
import { useNavigate } from "react-router-dom";

function ArticlesCard({
  id,
  image,
  title,
  time,
  authorName,
  authorPosition,
  authorAffiliation,
}) {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/articles/${id}`);
  };

  return (
    <div
      onClick={handleCardClick}
      className="relative flex flex-col bg-white shadow-lg rounded-xl overflow-hidden cursor-pointer transition-transform hover:scale-105 duration-200"
    >
      {/* Image Section */}
      <div className="relative w-full h-52">
        <img src={image} alt={title} className="w-full h-full object-cover" />
      </div>

      {/* Content Section */}
      <div className="p-4 flex flex-col flex-grow">
        <h3 className="text-lg font-bold text-gray-900 mb-2">{title}</h3>
        <p className="text-sm text-gray-500">{time}</p>

        <div className="flex items-center gap-3 mt-4">
          <div className="bg-gray-200 h-10 w-10 rounded-full flex items-center justify-center font-bold text-gray-600">
            {authorName.charAt(0)}
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-800">{authorName}</p>
            <p className="text-xs text-gray-500">
              {authorPosition} - {authorAffiliation}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ArticlesCard;
